export const state = {
  showDialog: false
};

export const mutations = {
  setDialog(state: any, showDialog: boolean): void {
    state.showDialog = showDialog;
  }
};
